import { takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import * as statsApi from '../api/admin-stats.api';
import {
  fetchEventAttendees,
  fetchEventStats,
  fetchEventsByCity,
  fetchPlatformStats,
} from './admin-stats.slice';

const apiSaga = createPanelApiSaga();

/**
 * GENEL GÖRÜNÜM PANOSU SAGALARI (kullanıcı kararı 2026-09-02 §3).
 *
 * Dördü de OKUMADIR: mutasyon yok, dolayısıyla invalidation da yok. Sayılar
 * ekran her açıldığında sunucudan tazelenir — pano bayat sayı göstermez.
 * Katılımcı dökümü sunucuda denetim kaydı düşürdüğü için YALNIZ satır eylemiyle
 * istenir; ekran açılışında kendiliğinden çağrılmaz.
 */
export function* adminStatsSaga() {
  yield takeLatest(
    fetchPlatformStats.request.type,
    apiSaga(fetchPlatformStats, statsApi.fetchPlatformStats),
  );
  yield takeLatest(
    fetchEventsByCity.request.type,
    apiSaga(fetchEventsByCity, statsApi.fetchEventsByCity),
  );
  yield takeLatest(
    fetchEventStats.request.type,
    apiSaga(fetchEventStats, statsApi.fetchEventStats),
  );
  yield takeLatest(
    fetchEventAttendees.request.type,
    apiSaga(fetchEventAttendees, (arg) => statsApi.fetchEventAttendees(arg.eventId, arg.query)),
  );
}
